export default "__VITE_ASSET__048bd607__"